import { useContext } from 'react';
import { WidgetContainerContext } from '@/core/widgets/contexts/widget-container-context';
import { WidgetContainer } from '@/core/widgets/model/widget-container';
import { NewsWidget } from '@/core/widgets/model/news-widget';
import { authService, useSessionId } from '@/core/auth/export';
import { analyticsService, AnalyticsEvent, AnalyticsTypes } from '@/shared/analytics/export';
import { openPopup } from '@/shared/util/export';
import { convertWidgetToReactPath } from '@/core/widgets/router/convert-widget-to-react-path';
import { useIsMobile } from '@/shared/hooks/export';

export type WidgetChromeContext = 'dashboard' | 'standalone' | 'dock' | 'tab';

export function useWidgetActions(
  widget: NewsWidget,
  context: WidgetChromeContext,
  widgetPath?: string,
) {
  const sessionId = useSessionId();
  const subject = authService.getSubjectData();
  const widgetContainer = useContext<WidgetContainer>(WidgetContainerContext);
  const isMobile = useIsMobile(768);

  const canPopout = context !== 'standalone' && !isMobile;

  const shareUrl =
    context === 'standalone' ? window.location.href : window.location.href + `?widget=${widget.id}`;

  const popout = () => {
    analyticsService.recordAnalyticsEvent(AnalyticsEvent.WIDGET_POPOUT, {
      subject,
      object: { type: AnalyticsTypes.WIDGET, id: widget.id },
      session: {
        id: sessionId,
      },
    });

    const queryParams = new URLSearchParams(widgetContainer.getPreferences<any>() ?? {});
    openPopup(
      `${convertWidgetToReactPath(widget.id, widgetPath)}?${queryParams.toString()}`,
      600,
      800,
      widget.id,
    );
  };

  const recordShare = () => {
    analyticsService.recordAnalyticsEvent(AnalyticsEvent.WIDGET_SHARED, {
      subject,
      object: { type: AnalyticsTypes.WIDGET, id: widget.id },
      session: {
        id: sessionId,
      },
    });
  };

  return { canPopout, shareUrl, popout, recordShare };
}
